import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingPhoto } from './types/Listing';

interface ListingPhotos {
  format: string;
  order: number[];
  rotate?: number;
}

export default (makeCall: MakeCall) =>
  (listingId: number, { order, rotate, format }: ListingPhotos) =>
    makeCall<ListingPhoto[]>(
      'PUT',
      `${APIV2_URL}/listing/${listingId}/photos`,
      {
        data: {
          order,
          ...(rotate ? { rotate } : {}),
        },
        query: { format },
      },
    );
